
import Vue from 'vue'
import errorHandler from '@/utils/errorHandler'

export default ({ affectedId, ignoredSupplies }) => {
  const payload = { authorized_project: affectedId, ignored_quantification_supplies: ignoredSupplies }
	return errorHandler(Vue.$http.post('purchase/requisition_sinister/', payload))
}


// WEBPACK FOOTER //
// ./src/services/purchase/makeRequisition.js